export enum ExtraProductStatus {
  notExtraProduct = 0,
  extraProdWithConcret = 1,
  singleExtraProduct = 2,
}
